import React, { useContext, useEffect, useState } from 'react';
import { BoxWrapper } from '../../../style';
import arrowIcon from "../../../images/arrow.png";
import { FormWrapper } from '../../../components/loan/style';
import Button from '../../../components/ui/Button';
import Alert from '../../../components/ui/Alert';
import { getDashboardData, getStateCityPincode, savePerssonalAddress } from '../../../Utils/api';
import { useNavigate } from 'react-router-dom';
import { getStorage, goBack, isEmpty, setStorage } from '../../../Utils/common';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { formValidation } from '../../../Utils/formValidation';
import ContextDashboard from '../../../Context/ContextDashboard';  // Correct default import
import ProgressBar from "../../../components/ProgressBar/ProgressBar";

const initialData = {
    pinCode: "",
    landmark: "",
    current_locality: "",
    address: "",
    residenceType: "",
};

const options = [
    { label: "Owned", value: "1" },
    { label: "Rented", value: "2" }
];

function CapturPersonalInformation() {
    const { message, setMessage, setps, logout, handleEvent } = useContext(ContextDashboard);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(initialData);
    const [formDataError, setFormDataError] = useState(initialData);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [pinCodeList, setPinCodeList] = useState([]);
    const [showSteps, setShowSteps] = useState(-1);
    const [toggle, setToggle] = useState(true);
    const [progressBar, setProgressBar] = useState(getStorage("step_percent"));

    const navigate = useNavigate();

    const submit = () => {
        // Validate form data
        const error = formValidation(formData, ["landmark"]);
        setFormDataError({ ...formDataError, ...error });

        const param = {
            profile_id: getStorage("cust_profile_id") || "",
            event_name: "residence_details",
            residence_type_id: formData.residenceType,
            residence_landmark: formData.landmark || "",  // Landmark can be empty now
            residence_address_2: formData.current_locality,
            residence_address_1: formData.address,
            residence_pincode: formData.pinCode
        };

        if (isEmpty(error)) {
            setLoading(true);
            savePerssonalAddress(param).then(resp => {
                setLoading(false);
                if (resp?.data?.Status === 1) {
                    setStorage("next_step", resp?.data?.Data?.next_step);
                    setStorage("step_percent", resp?.data?.Data?.step_percentage);
                    setMessage({ type: 'success', msg: resp?.data?.Message, place: "global" });
                    handleEvent(getStorage('next_step'));
                } else if (resp?.data?.Status === 4) {
                    logout();
                } else {
                    setMessage({ type: 'error', msg: resp?.data?.Message });
                }
            });
        }
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setFormDataError(prev => ({
            ...prev,
            [name]: ""
        }));
    };

    useEffect(() => {
        const params = {
            profile_id: getStorage("cust_profile_id") || "",
        };
        getDashboardData(params).then(resp => {
            if (resp?.data?.Status === 1) {
                const dashboardData = resp?.data || {};
                if (dashboardData) {
                    setFormData(prev => ({
                        ...prev,
                        address: dashboardData?.Data?.profile_details?.residence_address_1 || "",
                        current_locality: dashboardData?.Data?.profile_details?.residence_address_2 || "",
                        landmark: dashboardData?.Data?.profile_details?.residence_landmark || "",
                        pinCode: dashboardData?.Data?.profile_details?.residence_pincode || "",
                        residenceType: dashboardData?.Data?.profile_details?.residence_type_id || "",
                    }));
                }
            }
        });
    }, [logout]);

    useEffect(() => {
        if (!isEmpty(setps)) {
            checkStep(setps);
        }
    }, [setps]);

    const checkStep = (data) => {
        const steps = (data?.step_stage - 1);
        if (data?.step_complete_percent === 100) {
            setToggle(false);
        }
        setShowSteps(steps);
    };

    return (
        <>
            <ProgressBar value={`${progressBar}%`}>
                <div></div>
            </ProgressBar>
            {/* <BoxWrapper className="w-full sm:bg-gray-100 justify-center">
                <div className="formmainBox  flex gap-5  flex-col lg:flex-row  items-start rounded-lg">
                    <div className='flex gap-1 items-center justify-center mb-5 pointer border border-E5E5E5 rounded-lg px-6 py-1 group hover:bg-gray-100 hover:border-gray-200 hover:bg-white transition-all duration-300' onClick={() => goBack(navigate, "/my-dashboard/")}>
                        <img src={arrowIcon} alt="" className='w-4 mr-1 group-hover:-translate-x-1 transition-all duration-300' /> <span className='font-medium text-1D3557'>Back</span>

                    </div>
                    <div className="right lg:m-auto text-center right bg-white p-5 sm:p-10 text-center rounded-lg">
                        <h2 style={{ color: '#1D3557' }}>Current Residence Address</h2>
                        <p style={{ color: '#1D3557' }}>Ensure to provide correct residence address. No Surprise Visits, We Promise!</p>

                        <FormWrapper>
                            <Alert setMessage={setMessage} message={message} />
                            <div className="inputBox">
                                <Select
                                    label="Residence Type"
                                    name="residenceType"
                                    placeholder="Enter Residence"
                                    error={formDataError?.residenceType}
                                    onChange={onChange}
                                    value={formData?.residenceType}
                                    options={options}
                                    required={true}
                                />
                                <Input
                                    label="Address1"
                                    name="address"
                                    error={formDataError?.address}
                                    onChange={onChange}
                                    value={formData?.address}
                                    required={true}
                                />
                                <Input
                                    label="Address2"
                                    name="current_locality"
                                    error={formDataError?.current_locality}
                                    onChange={onChange}
                                    value={formData?.current_locality}
                                    required={true}
                                />
                                <Input
                                    label="Landmark"
                                    name="landmark"
                                    error={formDataError?.landmark}
                                    onChange={onChange}
                                    value={formData?.landmark}
                                // Landmark is now optional, no required prop
                                />
                                <Input
                                    label="Pin Code"
                                    name="pinCode"
                                    error={formDataError?.pinCode}
                                    onChange={onChange}
                                    value={formData?.pinCode}
                                    required={true}
                                />
                            </div>

                            <div className="button button  m-auto">
                                <Button className='bg-[#2D5F7A]' title="Continue" onClick={submit} loading={loading} />
                            </div>
                        </FormWrapper>
                    </div>
                </div>
            </BoxWrapper> */}
            <BoxWrapper className="min-h-screen ">

                <div className="max-w-4xl mx-auto">

                    {/* Back Button */}
                    <div
                        onClick={() => goBack(navigate, "/my-dashboard/")}
                        className="inline-flex items-center gap-2 mb-6 px-5 py-3 bg-white border border-gray-200 rounded-xl shadow-sm cursor-pointer hover:bg-gray-50 transition"
                    >
                        <img
                            src={arrowIcon}
                            alt="Back"
                            className="w-4 transition-transform duration-300 hover:-translate-x-1"
                        />
                        <span className="font-medium text-[#1D3557]">Back</span>
                    </div>

                    {/* Card */}
                    <div className="bg-white rounded-3xl shadow-lg p-5 sm:p-8 md:p-10">

                        {/* Header */}
                        <div className="text-center mb-8">

                            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-blue-50 flex items-center justify-center">
                                🏠
                            </div>

                            <h2 className="text-2xl sm:text-3xl font-bold text-[#1D3557]">
                                Current Residence Address
                            </h2>

                            <p className="mt-2 text-sm sm:text-base text-gray-500 max-w-xl mx-auto">
                                Ensure to provide correct residence address. No Surprise Visits, We Promise!
                            </p>

                        </div>

                        <FormWrapper>

                            <Alert
                                setMessage={setMessage}
                                message={message}
                            />

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                                <Select
                                    label="Residence Type"
                                    name="residenceType"
                                    placeholder="Select Residence Type"
                                    error={formDataError?.residenceType}
                                    onChange={onChange}
                                    value={formData?.residenceType}
                                    options={options}
                                    required
                                />

                                <Input
                                    label="Pin Code"
                                    name="pinCode"
                                    error={formDataError?.pinCode}
                                    onChange={onChange}
                                    value={formData?.pinCode}
                                    required
                                />

                                <div className="md:col-span-2">
                                    <Input
                                        label="Address Line 1"
                                        name="address"
                                        error={formDataError?.address}
                                        onChange={onChange}
                                        value={formData?.address}
                                        required
                                    />
                                </div>

                                <div className="md:col-span-2">
                                    <Input
                                        label="Address Line 2"
                                        name="current_locality"
                                        error={formDataError?.current_locality}
                                        onChange={onChange}
                                        value={formData?.current_locality}
                                        required
                                    />
                                </div>

                                <div className="md:col-span-2">
                                    <Input
                                        label="Landmark (Optional)"
                                        name="landmark"
                                        error={formDataError?.landmark}
                                        onChange={onChange}
                                        value={formData?.landmark}
                                    />
                                </div>

                            </div>

                            {/* Security Card */}
                            <div className="mt-8 flex gap-4 rounded-2xl border border-green-200 bg-green-50 p-5">

                                <div className="w-12 h-12 rounded-full bg-white shadow flex items-center justify-center shrink-0">
                                    🔒
                                </div>

                                <div>
                                    <h4 className="font-semibold text-[#1D3557]">
                                        Your information is secure
                                    </h4>

                                    <p className="text-sm text-gray-600 mt-1">
                                        We use bank-grade encryption to protect your personal information.
                                    </p>
                                </div>

                            </div>

                            {/* Button */}
                            <div className="mt-8">
                                <Button
                                    className="w-full bg-[#2D5F7A]"
                                    title="Continue"
                                    onClick={submit}
                                    loading={loading}
                                />
                            </div>

                        </FormWrapper>

                    </div>

                </div>

            </BoxWrapper>
        </>
    );
}

export default CapturPersonalInformation;